import { ChildId, ChildWithParentsIds } from 'types';

export const findParentsByChildId = (
    childrenWithParentsIds: ChildWithParentsIds[],
    childId: ChildId,
) =>
    childrenWithParentsIds.find((childWithParentsIds) => childWithParentsIds.childId === childId)
        ?.parentIds;
